// extracted by mini-css-extract-plugin
export var carrierTab = "_3q-0";
export var carrierTabActive = "_3q-1 _3q-0";
export var carrierTabInactive = "_3q-2 _3q-0";
export var carrierTabLabel = "_3q-3";
export var carrierTabLabelActive = "_3q-4 _3q-3";
export var carrierTabLabelInactive = "_3q-5 _3q-3";
export var carrierTabPercentage = "_3q-6";
export var carrierTabPercentageActive = "_3q-7 _3q-6";
export var carrierTabPercentageInactive = "_3q-8 _3q-6";
export var carrierTabWinnable = "_3q-9";
export var carrierTabWinnableActive = "_3q-a _3q-9";
export var carrierTabWinnableInactive = "_3q-b _3q-9";
export var comparisonContainer = "_3q-d";
export var missingRateButton = "_3q-n";
export var missingRateButtonActive = "_3q-o _3q-n";
export var missingRateButtonInactive = "_3q-p _3q-n";
export var missingRateButtonLabel = "_3q-q";
export var missingRateButtonLabelActive = "_3q-r _3q-q";
export var missingRateButtonLabelInactive = "_3q-s _3q-q";
export var sidebar = "_3q-c";
export var strategyButton = "_3q-e";
export var strategyButtonActive = "_3q-f _3q-e";
export var strategyButtonDescription = "_3q-k";
export var strategyButtonDescriptionActive = "_3q-l _3q-k";
export var strategyButtonDescriptionInactive = "_3q-m _3q-k";
export var strategyButtonInactive = "_3q-g _3q-e";
export var strategyButtonLabel = "_3q-h";
export var strategyButtonLabelActive = "_3q-i _3q-h";
export var strategyButtonLabelInactive = "_3q-j _3q-h";
export var unitToggleButton = "_3q-t";
export var unitToggleButtonActive = "_3q-u _3q-t";
export var unitToggleButtonInactive = "_3q-v _3q-t";
export var unitToggleButtonLabel = "_3q-w";
export var unitToggleButtonLabelActive = "_3q-x _3q-w";
export var unitToggleButtonLabelInactive = "_3q-y _3q-w";